import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { rCore } from '../../models/.catalog';
import pSifreDegistir from '../../models/pSifreDegistir';

export default class SifreDegistirApi extends ApiBase<pSifreDegistir, rCore> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/TumSifreDegis',
      }),
      options
    );
    this._ServiceUrl = '/services/Kullanici.asmx';
  }
}
